<template>
  <el-card>
    <div style="font-weight:700;">欢迎使用 宇航物流管理平台</div>
    <div style="margin-top:8px;color:#64748b;">左侧进入：订单管理 / 机场管理 / 系统管理</div>
  </el-card>
</template>

<script>
export default {
  name: 'Dashboard'
}
</script>
